module.exports = __webpack_public_path__ + "img/1440.e1ccc690.jpg";